"use client"

import styles from "./criteria.module.scss"
import skColors from "../../../../styles/skColors"
import StyledText from "../../../typography/typography-component"
import Image from "next/image"
import Button from "../../Button/Button"
import { useTranslations } from "next-intl"
import { Routes, useTypedRouter } from "../../../data/routes"
import { TrackedActions } from "../../../tracking/trackedActions"

const CriteriaSection = ({}) => {
  const router = useTypedRouter()
  const t = useTranslations("index")

  return (
    <div className={styles.criteriaContainer}>
      <div className={styles.criteriaTitle}>
        <StyledText color={skColors.turquoise[600]} variant={"h2"}>
          {t("eligibility.title")}
        </StyledText>
        <StyledText variant={"h3"}>{t("eligibility.subtitle")}</StyledText>
      </div>

      <div className={styles.criterias}>
        <div className={styles.criteriaBundle}>
          <Image
            width={160}
            src={"/svg/criteria/affected_area.svg"}
            height={160}
            alt={"affected area"}
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
          <StyledText color={skColors.turquoise[600]} className={styles.tags} variant={"tags"}>
            {t("eligibility.criteria.affected.title")}
          </StyledText>
          <StyledText variant={"pRegular"} className={styles.textSizeFix}>
            {t("eligibility.criteria.affected.desc")}
          </StyledText>
        </div>

        <div className={styles.criteriaBundle}>
          <Image
            width={160}
            src={"/svg/criteria/diagnosis.svg"}
            height={160}
            alt={"diagnosis"}
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
          <StyledText color={skColors.turquoise[600]} className={styles.tags} variant={"tags"}>
            {t("eligibility.criteria.diagnosis.title")}
          </StyledText>
          <StyledText variant={"pRegular"} className={styles.textSizeFix}>
            {t("eligibility.criteria.diagnosis.desc")}
          </StyledText>
        </div>

        <div className={styles.criteriaBundle}>
          <Image
            width={160}
            src={"/svg/criteria/krankenkasse.svg"}
            height={160}
            alt={"health insurance"}
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
          <StyledText color={skColors.turquoise[600]} className={styles.tags} variant={"tags"}>
            {t("eligibility.criteria.insurance.title")}
          </StyledText>
          <StyledText variant={"pRegular"} className={styles.textSizeFix}>
            {t("eligibility.criteria.insurance.desc")}
          </StyledText>
        </div>
      </div>

      <Button hug onClick={() => void TrackedActions.goToSelfCheck()} variant={"primary"}>
        {t("eligibility.cta")}
      </Button>
    </div>
  )
}

export default CriteriaSection
